// NestJS's default exception filter returns { statusCode, message, error } — `message` is a
// string for most exceptions but an array for class-validator failures. Surfacing it matters
// here specifically: duplicate-name (409) and self-lockout guard rejections need to explain
// *why* an action was blocked, which a generic "X failed" message would defeat.
export async function extractErrorMessage(res: Response, fallback: string): Promise<string> {
  try {
    const body = (await res.json()) as { message?: string | string[] };
    if (Array.isArray(body.message)) return body.message.join(', ');
    if (typeof body.message === 'string') return body.message;
  } catch {
    // body wasn't JSON or had no message field — fall through to the generic message
  }
  return fallback;
}
